import { LanguageSpec } from '../LanguageSpec';

export const en: LanguageSpec = {
  'menuRoutes.timeTracking': 'Time Tracking',
  'menuRoutes.orders': 'Orders',
  'menuRoutes.dayplan': 'Dayplan',
  'menuRoutes.weekplan': 'Weekplan',
  'menuRoutes.routines': 'Routines',
  'menuRoutes.newJob': 'New Job',
  'menuRoutes.runningJobs': 'Running Jobs',
  'menuRoutes.createSpecialJob': 'New Specialjob',
  'menuRoutes.specialJobs': 'Specialjobs',
  'menuRoutes.einmalAuftraege': 'One-time Jobs',
  'menuRoutes.settings': 'Settings',
  'project.singular': 'Project',
  'project.start': 'Start Project',
  'project.end': 'End',
  'project.resume': 'Resume',
  'project.endModal.title': 'End Project',
  'project.endModal.commentPlaceholder': 'Comment (optional)',
  'project.endModal.cancel': 'Cancel',
  'project.endModal.confirm': 'End',
  'project.autoPauseToast': 'Previous activity paused',

  'einmalAuftraege.toolbar': 'One-time Jobs',
  'einmalAuftraege.empty': 'No one-time jobs available',

  'runEinmalAuftrag.toolbar': 'Execute Job',
  'runEinmalAuftrag.pause': 'Pause',
  'runEinmalAuftrag.resume': 'Resume',
  'runEinmalAuftrag.end': 'Complete',
};
